import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/portfolio", label: "Portfolio", id: "portfolio" },
  { to: "/about", label: "About Us", id: "about" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const linkCls = ({ isActive }) =>
    `relative text-sm font-medium transition-colors duration-200 ${isActive ? "text-[#0D6EFD]" : "text-slate-700 hover:text-[#0B132B]"}`;
  return (
    <header data-testid="site-nav" className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow] duration-300 ${scrolled || open ? "bg-white/85 shadow-[0_1px_0_rgba(11,19,43,0.08)] backdrop-blur-xl" : "bg-transparent"}`}>
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="nav-logo-link"><Logo /></Link>
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <NavLink key={l.id} to={l.to} end className={linkCls} data-testid={`nav-${l.id}-link`}>{l.label}</NavLink>
          ))}
        </nav>
        <Link to="/contact" data-testid="nav-cta-button" className="group hidden items-center gap-1.5 rounded-full bg-[#0B132B] px-5 py-2.5 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#0D6EFD] md:inline-flex">
          Get in touch <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </Link>
        <button data-testid="nav-mobile-toggle" aria-label="Menu" onClick={() => setOpen((o) => !o)} className="rounded-full p-2 text-[#0B132B] md:hidden">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="flex flex-col gap-1 border-t border-slate-200 px-5 pb-6 pt-3 md:hidden">
          {LINKS.map((l) => (
            <NavLink key={l.id} to={l.to} end data-testid={`nav-mobile-${l.id}-link`} className={({ isActive }) => `font-display rounded-xl px-3 py-3 text-2xl font-bold ${isActive ? "text-[#0D6EFD]" : "text-[#0B132B]"}`}>{l.label}</NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
